var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-main main"},[_c('div',{staticClass:"htmldiv"},[(_vm.info.banner.length > 0)?_c('IndexSwiper',{style:({ height: '360px' }),attrs:{"bannerList":_vm.info.banner,"options":{ 
                id: 'swiper-banner', 
                pagination: true, 
                navigation: true, 
                showPage: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                speed: 500,
                loop: true,
                paginationClass: 'banner-pagination'
            }}}):_vm._e()],1),_c('div',{staticClass:"nsdiv htmldiv ofhidden"},[_c('div',{staticClass:"news-scroll wd30 ht310 fl"},[_c('Stitle',{class:'fs16',attrs:{"stitle":"推荐新闻","more":'/news/10'}}),_c('div',{staticClass:"ht25"}),(_vm.info.recommended_news.length > 0)?_c('IndexSwiper',{style:({ height: '300px' }),attrs:{"bannerList":_vm.info.recommended_news,"options":{ 
                        id: 'swiper-index-news', 
                        showPage: true, 
                        loop: true,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false
                        },  
                        effect:  'coverflow'
                    }}}):_vm._e()],1),_c('div',{staticClass:"news wd40 ht310 fl pl35 pr35"},[_c('Stitle',{class:'fs16',attrs:{"stitle":"学院新闻","more":'/news/11'}}),_c('div',{staticClass:"ht15"}),_c('News',{staticClass:"news-cur pt5 news-show-date",attrs:{"type":"notice","newsList":_vm.info.college_news,"link":'news/detail'}})],1),_c('div',{staticClass:"news wd30 ht310 fl"},[_c('Stitle',{class:'fs16',attrs:{"stitle":"通知公告","more":'/news/12'}}),_c('div',{staticClass:"ht15"}),_c('News',{staticClass:"news-cur pt5 news-show-date",attrs:{"type":"notice","newsList":_vm.info.notice,"link":'news/detail'}})],1)]),_c('Links'),(Object.keys(_vm.floating_pop).length)?_c('ImgMove',{attrs:{"article":_vm.floating_pop}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }